import SetupPackageFulfillments from './setup-package-fulfillments';

export default {
  SetupPackageFulfillments,
};
